import jQuery from 'netxcore@netx/core/lib/jquery-netx';

jQuery.fn.extend({
	/**
	 * Material design
	 * @override
	 */
	disable() {
		this.attr('disabled', true);
		this.addClass('disabled');
		if (this.hasClass('mdc-list-item')) {
			this.addClass('mdc-list-item--disabled');
		}
		return this;
	},
	/**
	 * Material design
	 * @override
	 */
	enable() {
		this.attr('disabled', false);
		this.removeClass('disabled');
		if (this.hasClass('mdc-list-item')) {
			this.removeClass('mdc-list-item--disabled');
		}
		return this;
	},
});

export default jQuery;
